import { useEffect, useState } from "react";
import { getUserRole } from "../utils/firestoreUser";
import { auth } from "../firebase";

export default function useUserRole(userId) {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    let mounted = true;
    
    async function fetchRole() {
      if (!userId) { 
        if (mounted) {
          setRole(null);
          setLoading(false);
        }
        return; 
      }
      
      try {
        setLoading(true);
        const r = await getUserRole(userId);
        if (mounted) {
          setRole(r);
          setLoading(false);
        }
      } catch (err) { 
        console.error('Error fetching user role:', err);
        if (mounted) {
          setRole(null);
          setLoading(false);
        }
      }
    }
    
    fetchRole();
    return () => { 
      mounted = false; 
    };
  }, [userId]);
  
  return { role, loading };
}
